import { render, staticRenderFns } from "./Dropzone.vue?vue&type=template&id=8c8e7d54&"
import script from "./Dropzone.vue?vue&type=script&setup=true&lang=js&"
export * from "./Dropzone.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Dropzone.vue?vue&type=style&index=0&id=8c8e7d54&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports